import classes from "./HeaderList.module.css";

const LabelValue = ({ data }) => {


    return <p className={classes.wrapper}>
        <span className={classes.label}>{data?.label}</span> <span className={classes.value}>{data?.value}</span>
    </p>
}
const HeaderList = ({ data }) => {

    return (<div className={classes.reportDetails}>
        {data?.map(element => <LabelValue key={data?.label} data={element} />)}
    </div>);
}

export default HeaderList;